import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editSkillModal",
  "data-toggle": "modal",
  ref: "editSkillModalRef"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "editSkillModal"
  }, "Edit existing skill"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "label fs-5" }, "Select level", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "label fs-5" }, "Edit experience", -1)
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelsDropdown = _resolveComponent("LevelsDropdown")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.$can('settings_skill_access', 'all'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_LevelsDropdown, {
                    modelValue: _ctx.levelId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.levelId) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: _ctx.experience,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.experience) = $event)),
                rows: "3"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateAndSave && _ctx.validateAndSave(...args))),
            type: "button",
            class: "btn btn-success"
          }, " Save ")
        ])
      ])
    ])
  ], 512))
}